import React, { useMemo } from 'react'
import TextLink from 'components/Luxkit/TextLink'

import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { sum } from 'lib/array/arrayUtils'
import * as Analytics from 'analytics/analytics'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import Expander from 'components/utils/Expander'
import useToggle from 'hooks/useToggle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import { rem } from 'polished'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'

const ExpandedDescriptionMarkDownRender = styled(MarkdownRender)`
  margin-top: ${rem(8)};
`

interface Props {
  description: string;
  facilities?: string;
  className?: string;
  promotions?: Array<OfferPackageOptionView>;
}

const trackReadMoreToggle = (expanded: boolean) => {
  if (expanded) {
    Analytics.trackClientEvent({
      subject: 'read_less',
      action: 'pressed',
      category: 'offer_page',
      type: 'interaction',
    })
  } else {
    Analytics.trackClientEvent({
      subject: 'read_more',
      action: 'pressed',
      category: 'offer_page',
      type: 'interaction',
    })
  }
}

export default function OfferDescription(props: Props) {
  const {
    description,
    className,
  } = props

  const [expanded, toggleReadMore] = useToggle()
  const [shortDescription, expandedDescription] = useMemo(() => {
    const short = description.split('\n').reduce((acc, value) => {
      if (sum(acc, acc => acc.length) < 500) {
        acc.push(value)
      }
      return acc
    }, [] as Array<string>).join('\n')
    return [short, description.replace(short, '')]
  }, [description])

  function toggle() {
    toggleReadMore()
    trackReadMoreToggle(expanded)
  }

  return (
    <div className={className}>
      {shortDescription && <>
        <MarkdownRender type="compact" fontSize="medium" content={shortDescription} />
        <SoftOfferPageWalledGarden>
          {expandedDescription && <VerticalSpacer gap={16}>
            <Expander expanded={expanded}>
              <ExpandedDescriptionMarkDownRender type="compact" fontSize="medium" content={expandedDescription} />
            </Expander>
            <TextLink endIcon={<DropdownChevron direction={expanded ? 'up' : 'down'}/>} size="medium" onClick={toggle}>
              Read {expanded ? 'less' : 'more'}
            </TextLink>
          </VerticalSpacer>}
        </SoftOfferPageWalledGarden>
      </>}
    </div>
  )
}
